import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { showToast } from '../components/utils/toast';
import { isForbiddenError } from '../helpers/matterRequestErrorHelper';
import { SYSTEM_PARAMETERS_QUERY_KEY } from './useFetchSystemParameters';

/**
 * A 403 means the rights the screens were gated on are out of date, so they are refetched and the
 * actions follow the current rights instead of staying until the cached parameters expire.
 */
export const useMatterRequestMutationErrorHandler = (
  resolveErrorMessage: (error: AxiosError) => string,
) => {
  const queryClient = useQueryClient();

  return (error: AxiosError) => {
    showToast('error', resolveErrorMessage(error));
    if (isForbiddenError(error)) {
      queryClient.invalidateQueries({ queryKey: [SYSTEM_PARAMETERS_QUERY_KEY] });
    }
  };
};
